const palette = {};

export default palette;
